<style lang="less" scoped>
  .fl{ float: left; }
  .fr{ float: right; }
  .pd16{ padding: 16px 0; }
  .clear{ clear: both; }
  .container{ min-height: 250px; background: #fff; overflow-y: auto;
    .info_list_box{
      .info_list{ border-bottom: 2px dashed #999; position: relative;
        .pac_subject{ width:70px; text-align: center; font-size: 18px;float: left; }
        .pac_questions{ margin-left: 70px;
          .pac_ques{ border: 1px solid #e5e7ea; position: relative;
            .pac_foot{ border-top: 1px solid #e5e7ea; padding: 8px 16px; overflow: hidden; background: #e5e7ea;
              >div{ display: inline-block; padding:4px; }
              .pac_look{ padding: 0; margin-left:8px;}
            }
            .pac_tage{ position: absolute; right:0; top:0; }
            .pac_about{ font-size: 12px; color: #666; padding: 8px 16px;
              >div{ display: inline-block; border-right: 1px solid #666; padding-right: 8px; margin-right: 8px;
                &:last-child{ border: none; }
              }
            }
          }
          .pac_analysis{ border: 1px solid #e5e7ea; margin-top: 8px;
            p{ font-size: 18px; }
          }
        }
      }
    }
  }
  .view_parsing{
    border:1px solid #e5e7ea;
    margin:10px 0 0 70px;
    padding: 10px;
    >div{
      margin-bottom: 10px;
      font-size: 16px;
    }
  }
</style>
<template>
  <div class="container">
    <div class="info_list_box" v-for="(r,index) in questionList" :key="r.id">
      <div class="info_list pd16">
        <div class="pac_subject">题{{index+1}}</div>
        <div class="pac_questions">
          <div class="pac_ques">
            <div class="pac_info pd16" v-html="r.questionContent"></div>
            <div class="pac_about">
              <div>来源：{{r.origin}}</div>
              <div>教材：{{r.subjectName}}</div>
              <div>资源积分：{{r.price}}</div>
            </div>
            <div class="pac_foot">
              <div>贡献者：{{r.creatorName}}</div>
              <div>创建：{{r.createTime}}</div>
              <div>题型：{{r.questionTypeName}}</div>
              <div class="pac_look fr">
                <el-button @click="seeAnalysis(r,index)" type="text" size="mini"><i class="fa fa-eye"></i>解析</el-button>
              </div>
              <div class="pac_look fr">
                <bro_dow_col_paper v-if="r.creatorId!=userId"  ref="bro_dow_col_paper" :type="1" :styleCss=3 :resource="r" :extPro="2" class="bar_info"></bro_dow_col_paper>
              </div>
            </div>
            <div class="pac_tage">
              <el-tag type="danger">{{r.typeName}}</el-tag>
            </div>
          </div>
        </div>
        <div class="view_parsing" style="display: none;">
          <div v-html="r.questionResult"></div>
          <div v-html="r.analysis"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props:{
      subPaperList:{type:Array},//分卷
    },
    data(){
      return{
        questionList:[],
        analysisContent:'',//解析内容
        dialogVisible: false,
        isOpen:false,//查看解析控制
        userId:window.appframe.$store.state.userInfo.id,//当前用户id
      }
    },
    mounted () {
      let vm= this;
      setTimeout(i=>{
        vm.init();
      },500)

    },
    methods: {
      init(){
        let vm = this;
        let subPapers=[];
        if(vm.subPaperList==null){
          return
        }
        if(vm.subPaperList.length>=2){
          let list1 = vm.subPaperList[0].questionList;
          let list2 = vm.subPaperList[1].questionList;
          subPapers=_.union(list1,list2);
        }else {
          //只有一个分卷
          subPapers=vm.subPaperList[0].questionList;
        }
        for(let l=0;l<subPapers.length;l++){
          subPapers[l].isOpen=false;
        }
        let temp1 = _.filter(subPapers,function (v) {
          return v.choiceType == true;
        })
        let temp2 = _.filter(subPapers,function (v) {
          return v.choiceType == false;
        })
        vm.questionList=  _.sortBy(temp1,'questionTypeCode').concat(_.sortBy(temp2,'questionTypeCode'));
      },
      //处理试题
      dispose(){
        let  vm = this;
        vm.questionList = vm.resourceInfo.subPaperList[0].questionList;
      },
      //查看解析
      seeAnalysis(r,index){
        let vm= this;
        r.isOpen = !r.isOpen
        if(r.isOpen){
          $(".info_list_box").eq(index).find(".view_parsing").show()
        }else{
          $(".info_list_box").eq(index).find(".view_parsing").hide()
        }
      },
    }

  }
</script>



// WEBPACK FOOTER //
// src/commonplugin/common/comm_homework.vue